import axios from 'axios';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 30000,
  withCredentials: !!import.meta.env.VITE_CORS_ENABLED,
});

export function configureAxios(store) {
  api.interceptors.request.use((config) => {
    store.dispatch('app/request', config);
    return config;
  }, (error) => {
    store.dispatch('app/response', error);
    return Promise.reject(error);
  });

  api.interceptors.response.use((response) => {
    store.dispatch('app/response', response);
    return response;
  }, (error) => {
    store.dispatch('app/response', error);
    return Promise.reject(error);
  });
}
